import { useImmer } from "use-immer";
import React, { useContext, useEffect, useState } from "react";
import { dataList, detailsData } from "./dummydata";
import { useProductionChartQuery } from "./useProductionChartQuery";
import { useDebounce, useDebouncedCallback } from "use-debounce";
import { usePermission, useStoreSelectQueries } from "../../../shared";
import { addDays } from "date-fns";
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../../store";

export const useProductionChart = (props) => {
  const isEditable = usePermission("production-chart-modify");
  const isFututeChartVisble = usePermission("future-chart-view");
  const { list = false, detId = null, futureList = false } = props;

  const { pathname, state } = useLocation();
  const isStoreAdmin = pathname.includes("store-admin");
  const navigate = useNavigate();
  const { globalData } = useContext(AppContext);
  const [toggleAllProducts, setToggleAllProducts] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [editedMap, setEditedMap] = useState({});
  const [focusedField, setFocusedField] = useState(null);
  const [productionchart, setProductionchart] = useImmer({
    isBatchSplit: false,
    templateBatchDetails: [],
    allLastBatchWeightZero: false,
    batchTemplateDetails: {},
    batchsplitDetails: [],
    batchIndex: null,
    productIndex: null,
    batchDetails: [],
    isBowlcapaciytyExceed: false,
    isShowErrorMessage: false,
    selectedRecipeIndex: 0,
    selectedBatchPriority: 1,
    selectedBatchIndex: 0,
    shouldInitializeTempId: false,
    selectedOtherRecipe: null,
    groupedDatas: [],
    templateResultRows: [],
    totalTemplateSearchResult: 0,
    category_index: 0,
    result: [],
    data: {
      id: 0,
      name: "",
      symbol: "",
      ignore: false,
      no_of_decimals: 0,
      include_decimal_places: false,
      is_default: null,
    },
    filter: {
      search: "",
      category: null,
    },
    isRecipe: 0,
    storeFilter: [],
    recipeList: [],
    updateValue: [],
    allData: [],
    datas: [],
    isChanged: false,
    store: "",
    templateDate: "",
    filters: {
      search: "",
      stores: [],
      date: futureList
        ? [
            {
              startDate: addDays(new Date(), 7),
              endDate: addDays(new Date(), 7),
              key: "selection",
            },
          ]
        : [],
    },
    tempdate: [
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ],
    futureTempdate: [
      {
        startDate: addDays(new Date(), 7),
        endDate: addDays(new Date(), 7),
        key: "selection",
      },
    ],
    search: "",
    isOpen: false,
    isDatePickerOpen: false,
    isDatePickerOpenfuture: false,
    isTemplateOpen: false,
    id: 0,
    del_id: 0,
    details: {},
    selectedStore: [],
    isLoading: true,
    isList: false,
    alltemplateList: [],
    tempateList: [],
    dataList: [],
    temp_id: "",
    temp_index: 0,
    filterData: [],
    completeTemplateCategories: [],
  });

  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 50,
  });
  const [sorting, setSorting] = useState([]);
  const [debouncedText] = useDebounce(productionchart.filters.search, 1000);

  const productListRef = React.useRef(null);
  const ingredientListRef = React.useRef(null);

  const {
    listQuery,
    futureListQuery,
    productionChartDetails,
    templateList,
    categorylistQuery,
    recipelistQuery,
    editTemplate,
    downloadProductionChart,
    updateProductionchartBatchSplit,
    downloadProductionChartByCategory,
  } = useProductionChartQuery({
    list,
    futureList,
    detId,
    pagination,
    debouncedText,
    sorting,
    storeId: productionchart.filters.stores,
    dates: productionchart.filters.date,
    isRecipe: productionchart.isRecipe,
    setProductionchart,
    productionchart,
    selectedIndex,
    isCategoryBasedOtherRecipes: 1,
  });

  const { listQuery: storeList } = useStoreSelectQueries({
    storeList: (list || futureList) && !isStoreAdmin,
  });

  const hasAnyBatchError = (productionchart) => {
    // 1. Any batch in any product has hasError === true
    const anyBatchHasError = productionchart?.batchDetails?.some((batch) =>
      (batch.products || []).some((product) =>
        (product.batches || []).some((b) => b?.hasError === true)
      )
    );
    return anyBatchHasError;
  };

  function anyBatchColumnAllWeightZero(productionchart) {
    for (const recipe of productionchart.batchDetails || []) {
      const products = recipe.products || [];
      if (products.length === 0) continue;

      const batchCount = products[0]?.batches?.length || 0;

      for (let batchIndex = 0; batchIndex < batchCount; batchIndex++) {
        // Check if all products have weight 0 (or missing) at this batchIndex
        const isAllZero = products.every((product) => {
          const batches = product.batches || [];
          if (batchIndex >= batches.length) return true; // treat missing as 0
          return (batches[batchIndex]?.weight || 0) === 0;
        });

        if (isAllZero) {
          return true; // Found a batch column where all weights are zero
        }
      }
    }
    return false; // No such batch column found
  }

  const hasLastBatchWeightZero = ({ productionchart, type }) => {
    let anyBatchColumnAllZero = anyBatchColumnAllWeightZero(productionchart);

    setProductionchart((draft) => {
      draft.allLastBatchWeightZero = anyBatchColumnAllZero;
    });
    if (anyBatchColumnAllZero === false) {
      onUpdate(type);
    }
  };
  useEffect(() => {
    if (state) {
      setProductionchart((draft) => {
        draft.filters.date = state.date;
      });
    }
  }, [state]);

  useEffect(() => {
    if (!productionChartDetails?.isFetching) {
      setProductionchart((draft) => {
        draft.selectedStore =
          productionChartDetails?.data?.stores &&
          productionChartDetails?.data?.stores[0];
        draft.templateDate = productionChartDetails?.data?.date;
        draft.isLoading = false;
      });
    }
  }, [productionChartDetails.isFetching]);

  useEffect(() => {
    if (templateList.data) {
      setProductionchart((draft) => {
        draft.alltemplateList = templateList.data;
        draft.tempateList = templateList.data;
      });
    }
  }, [templateList.isFetching]);

  const handleModal = (data) => {
    setProductionchart((draft) => {
      draft.isOpen = data;
      draft.shouldInitializeTempId = true;
      draft.isBowlcapaciytyExceed = false;
    });
    setSelectedIndex(0);
  };
  const handleTemplateModal = (data) => {
    setProductionchart((draft) => {
      draft.isTemplateOpen = data;
    });
  };
  const handleSelectStore = (data, items) => {
    setProductionchart((draft) => {
      draft.selectedStore = productionChartDetails.data?.stores.find(
        (i) => i.store_id === data?.store_id
      );
      draft.selectedRecipeIndex = 0;
      draft.selectedBatchIndex = 0;
      draft.selectedBatchPriority = 1;
    });
  };

  // Finds the first valid item based on category mode and toggle state
  const findFistItem = (products, allProducts, isCategory) => {
    let response = {
      selectedItem: null,
      selectedIndex: 0,
    };

    if (products?.length === 0) return response;

    switch (isCategory) {
      case true:
        if (allProducts) response.selectedItem = products[0].recipes[0];
        else {
          let i = 0;
          for (const category of products) {
            const recipe = category.recipes?.find((r) => r.show_in_chart);
            if (recipe) {
              response.selectedItem = recipe;
              response.selectedIndex = i;
              return response;
            }
            i++;
          }
        }
        break;
      default:
        response.selectedItem = products[0];
        break;
    }
    return response;
  };

  // Determines and sets the default "other recipe" selection
  const selectDefaultOtherRecipe = (otherRecipes) => {
    const isCategoryBased = Array.isArray(otherRecipes[0]?.recipes);
    const response = findFistItem(
      otherRecipes,
      toggleAllProducts,
      isCategoryBased,
    );

    setProductionchart((draft) => {
      draft.selectedOtherRecipe = response.selectedItem;
      draft.selectedRecipeIndex = response.selectedIndex;
    });
  };

  // Runs when selected store changes
  // Ensures a default recipe is selected when store data loads
  useEffect(() => {
    const otherRecipes = productionchart.selectedStore?.other_recipes;
    if (otherRecipes?.length > 0) {
      selectDefaultOtherRecipe(otherRecipes);
    }
  }, [productionchart?.selectedStore]);

  // Runs when "All Products" toggle changes
  // Re-selects a valid recipe if current one is no longer eligibleF
  useEffect(() => {
    const isShowInChartItemSelected =
      productionchart.selectedOtherRecipe?.show_in_chart;
    const otherRecipes = productionchart.selectedStore?.other_recipes;

    // Recalculate only if current selection is invalid
    if (otherRecipes?.length > 0 && !isShowInChartItemSelected) {
      selectDefaultOtherRecipe(otherRecipes);
    }
  }, [toggleAllProducts]);

  useEffect(() => {
    if (
      productionchart.isOpen &&
      productionchart.dataList?.length > 0 &&
      productionchart.shouldInitializeTempId
    ) {
      setProductionchart((draft) => {
        draft.temp_id = productionchart.dataList[0]?.template_id; // Set temp_id from dataList
        draft.temp_index = 0;
        draft.shouldInitializeTempId = false; // Prevent further executions
      });
    }
  }, [
    productionchart.isOpen,
    productionchart.dataList,
    productionchart.shouldInitializeTempId,
  ]);
  useEffect(() => {
    if (
      (productionchart?.templateDate && productionChartDetails?.data?.stores) ||
      (productionchart?.store && productionChartDetails?.data?.stores)
    ) {
      if (productionchart?.store) {
        let storeDetail = productionChartDetails?.data?.stores.find(
          (i) => i.store_id === productionchart?.store
        );
        handleSelectStore(storeDetail, productionchart?.dataList);
      } else {
        handleSelectStore(
          productionChartDetails?.data?.stores[0],
          productionchart?.dataList
        );
      }
    }
  }, [
    productionchart.templateDate,
    productionChartDetails?.data?.stores,
    productionchart.store,
  ]);
  const searchHandler = (v) => {
    setProductionchart((draft) => {
      draft.filters.search = v;
    });
  };

  const handleStoreSelect = (e, v) => {
    setProductionchart((draft) => {
      draft.filters.stores = v;
    });
  };

  const onChangeDate = (e) => {
    setProductionchart((draft) => {
      draft.tempdate = e;
    });
  };

  const onChangeDateFuture = (e) => {
    setProductionchart((draft) => {
      draft.futureTempdate = e;
    });
  };

  const handleDateChangeApply = (e) => {
    setProductionchart((draft) => {
      draft.filters.date = draft.tempdate;
      draft.isDatePickerOpen = false;
    });
  };

  const handleViewCharts = (e) => {
    setProductionchart((draft) => {
      draft.filters.date = draft.futureTempdate;
      draft.isDatePickerOpenfuture = false;
    });

    navigate(
      isStoreAdmin
        ? "/store-admin/production-charts/futureChart"
        : "/production-charts/futureChart",
      {
        state: { date: productionchart.futureTempdate },
      }
    );
  };

  const handleIsOpen = (e) => {
    setProductionchart((draft) => {
      draft.isDatePickerOpen = e;
    });
  };
  const handleIsOpenFuture = (e) => {
    setProductionchart((draft) => {
      draft.isDatePickerOpenfuture = e;
    });
  };

  const onSearchChange = (string) => {
    setProductionchart((draft) => {
      draft.tempateList = draft.alltemplateList.filter((o) =>
        Object.keys(o).some((k) =>
          o["template_name"].toLowerCase().includes(string.toLowerCase())
        )
      );
    });
  };
  useEffect(() => {
    if (!productionchart.isTemplateOpen) {
      setProductionchart((draft) => {
        draft.tempateList = draft.alltemplateList;
      });
    }
  }, [productionchart.isTemplateOpen]);

  const searchFn = (value, data = []) => {
    if (!value || !Array.isArray(data))
      return { result: data, totalSearchResult: 0 };

    let totalSearchResult = 0;
    const searchValue = value.toLowerCase();
    const result = [];

    for (let i = 0; i < data.length; i++) {
      const category = data[i];
      const subRows = category?.subRows || [];

      if (!subRows || !subRows.length) continue;

      const matchedSubRows = [];

      for (let j = 0; j < subRows.length; j++) {
        const name = subRows[j].name;
        if (name && name.toLowerCase().includes(searchValue)) {
          matchedSubRows.push(subRows[j]);
          totalSearchResult++;
        }
      }

      if (matchedSubRows.length) {
        result.push({ ...category, subRows: matchedSubRows });
      }
    }

    return { result, totalSearchResult };
    // if (!value || !data) return data;

    // const searchValue = value.toLowerCase();

    // return data
    //   ?.map((category) => {
    //     const filteredSubRows = category?.subRows?.filter((subRow) => {
    //       return subRow.name?.toLowerCase().includes(searchValue);
    //     });

    //     return filteredSubRows.length > 0
    //       ? { ...category, subRows: filteredSubRows }
    //       : null;
    //   })
    //   .filter(Boolean)
    //   .sort(
    //     (a, b) => a.subcategory_display_order - b.subcategory_display_order,
    //   );
  };

  const handleCustomTableChange = () => {
    let groupedData = productionchart?.dataList[
      productionchart?.temp_index
    ]?.recipeList?.reduce((result, product) => {
      if (!result[product.category_id]) {
        result[product.category_id] = {
          category_id: product.category_id,
          category_name: product.category_name,
          template_id: productionchart?.temp_id,
          subRows: [],
        };
      }
      result[product.category_id].subRows.push(product);
      return result;
    }, {});
    setProductionchart((draft) => {
      draft.groupedDatas = groupedData;
    });
  };
  useEffect(() => {
    if (recipelistQuery.data) {
      setProductionchart((draft) => {
        draft.recipeList = recipelistQuery.data.map((obj) => {
          return {
            ...obj,
            wastage: 0,
            quantity: 0,
            isChanged: false,
          };
        });
      });
    }
  }, [recipelistQuery.data]);

  const handleRecipes = async () => {
    try {
      const recipes = [];
      const filteredRecipes = productionchart.recipeList?.filter(
        (i) => i.category_id === productionchart?.chipCategoryId
      );
      filteredRecipes?.forEach((item) => {
        if (!recipes.find((ri) => ri.id === item.subcategory_id)) {
          recipes.push({
            id: item.subcategory_id,
            recipe_name: item.subcategory_name,
            subRows: [],
          });
        }
      });
      if (recipes) {
        filteredRecipes?.forEach((item) => {
          var findRecipe = recipes.find((ri) => ri.id === item.subcategory_id);
          if (findRecipe) {
            findRecipe.subRows.push({
              id: item.id,
              recipe_name: item.name,
              status: item.status,
              store: item.stores,
              type: item.type,
            });
          }
        });
      }
      return recipes;
    } catch (err) {
      return [];
    }
  };
  const onChangeFilter = (e, data, i) => {
    setProductionchart((draft) => {
      draft.category_index = i;
      draft.filter.category = e.id;
      draft.filter.selectedCategory = e;
      draft.datas = draft.allData.filter((v) => e.id === v.category_id);
      draft.filter.search = "";
    });
  };

  const searchCallback = useDebouncedCallback((value, fullData = {}) => {
    let templateResultRows = productionchart.result;
    let totalTemplateSearchResult = 0;
    if (value) {
      const { result, totalSearchResult } = searchFn(
        value,
        Object.values(fullData) || productionchart.result,
      );
      templateResultRows = result;
      totalTemplateSearchResult = totalSearchResult;
    }
    setProductionchart((draft) => {
      draft.filter.search = value;
      draft.templateResultRows = templateResultRows;
      draft.totalTemplateSearchResult = totalTemplateSearchResult;
    });
  }, 1000);

  const onTemplateSearchChange = (value, fullData = null) => {
    searchCallback(value, fullData);
  };

  const resetRegenerateSearch = () => {
    const { result, totalSearchResult } = searchFn("", productionchart?.result);
    setProductionchart((draft) => {
      draft.filter.search = "";
      draft.templateResultRows = result;
      draft.totalTemplateSearchResult = totalSearchResult;
    });
  };

  const updateTableData = (rowIndex, columnId, value, row, key) => {
    function updateDatalist(arr, key) {
      return arr?.map((v) => {
        if (v.category_id === row.category_id) {
          return {
            ...v,
            subRows: v.subRows.map((val) => {
              if (val.id === row.id) {
                return { ...val, [key]: value };
              } else return val;
            }),
          };
        } else return v;
      });
    }
    function updateOrAddObject(row, value, key) {
      const { id, wastage, quantity } = row;
      let arr = productionchart.updateValue;
      let isHave = arr?.some((v) => v.recipe_id === id);
      if (isHave) {
        arr = productionchart.updateValue.map((data) => {
          if (data.recipe_id === id) {
            return {
              ...data,
              [key]: Number(value),
              isChanged: true,
            };
          } else
            return {
              ...data,
              isChanged: true,
            };
        });
      } else
        arr = [
          ...arr,
          {
            recipe_id: id,
            wastage: wastage,
            quantity: quantity,
            isChanged: true,
            [key]: Number(value),
          },
        ];
      return arr;
    }
    function updateValue(row, value, key) {
      const { id, wastage, quantity } = row;

      const arr = productionchart?.dataList?.map((data, index) => {
        if (index === productionchart.temp_index) {
          return {
            ...data,
            recipeList: data?.recipeList?.map((item) => {
              if (item.id === id) {
                return {
                  ...item,
                  [key]: Number(value),
                  isChanged: true,
                };
              } else return item;
            }),
          };
        } else return data;
      });
      return arr;
    }
    setProductionchart((draft) => {
      draft.datas = updateDatalist(draft.datas, key);
      draft.allData = updateDatalist(draft.allData, key);
      draft.updateValue = updateOrAddObject(row, value, key);
      draft.dataList = updateValue(row, value, key);
      draft.isChanged = true;
    });
  };
  useEffect(() => {
    if (productionchart?.store || productionchart.isRecipe) {
      setProductionchart((draft) => {
        draft.storeFilter = productionChartDetails?.data?.stores?.filter(
          (item) => item?.store_id === productionchart?.store
        );
      });
    }
  }, [productionchart?.store, productionchart.isRecipe]);

  useEffect(() => {
    // Construct other recipes array while grouping
    const getOtherRecipes = (otherRecipes = []) => {
      const isCategoryBased = Array.isArray(otherRecipes[0]?.recipes);
      const products = isCategoryBased
        ? otherRecipes.flatMap((recipe) => recipe.recipes)
        : otherRecipes;

      return products;
    };

    if (
      productionchart?.storeFilter?.length &&
      productionchart.recipeList.length
    ) {
      const groupedData = getOtherRecipes(
        productionchart?.storeFilter[0]?.other_recipes
      ).reduce((acc, item) => {
        const { template_id, template_name } = item;

        if (!acc[template_id]) {
          acc[template_id] = {
            template_id,
            template_name,
            recipes: [],
          };
        }

        acc[template_id].recipes.push(item);
        return acc;
      }, {});

      let x = Object.values(groupedData);
      let y = x.map((data) => {
        let a = data.recipes.sort((a, b) => a.recipe_id - b.recipe_id);
        let b = productionchart.recipeList.map((data) => {
          if (data?.id === a.at(-1)?.recipe_id) {
            const val = {
              ...data,
              ...a.at(-1),
            };
            a.pop();
            return val;
          } else return data;
        });

        const updatedY = b.map((yItem) => {
          const xItem = a.find((xItem) => xItem.recipe_id === yItem.id);
          return xItem
            ? { ...yItem, quantity: xItem.quantity, wastage: xItem.wastage }
            : yItem;
        });
        return { ...data, recipeList: updatedY };
      });

      setProductionchart((draft) => {
        draft.dataList = y;
      });
    }
  }, [productionchart.storeFilter, productionchart.recipeList]);

  const onStoreChange = ({ target, data }) => {
    const storeFilter = data.find((i) => i.store_id === target?.value);
    setProductionchart((draft) => {
      draft.store = target?.value;
      draft.isRecipe = productionchart.isRecipe === 0 ? 1 : 0;
      draft.isList = true;
      draft.temp_index = 0;
    });
  };

  const convertedData = productionchart?.dataList?.map((template) => {
    const { template_id, template_name } = template;

    const recipes = template?.recipeList?.map((recipe) => ({
      recipe_id: recipe.id,
      quantity: recipe.quantity,
      wastage: recipe.wastage,
      isChanged: recipe.wastage > 0 || recipe.quantity > 0 ? true : false,
    }));

    return {
      template_id,
      recipes: recipes?.filter((i) => i.isChanged === true),
    };
  });

  const filterRecipeList = convertedData?.map((i) => {
    return i?.recipes?.filter((p) => p?.isChanged === true);
  });

  const onUpdate = (type) => {
    let payload = {};
    if (type === "initial") {
      payload = {
        date: productionchart?.templateDate,
        store_id: productionchart?.store,
        templates: convertedData,
        edit_status: 0,
      };
    } else if (type === "secondary") {
      payload = {
        date: productionchart?.templateDate,
        store_id: productionchart?.store,
        templates: convertedData,
        edit_status: 1,
      };
    }
    editTemplate.mutate({ payload, handleModal });
  };
  const handleTemplateChange = (e, id) => {
    setProductionchart((draft) => {
      draft.temp_index = e;
      draft.temp_id = id;
    });
    setSelectedIndex(0);
  };

  useEffect(() => {
    if (productionchart?.isOpen) {
      setProductionchart((draft) => {
        draft.store = productionchart?.selectedStore?.store_id;
        draft.isRecipe = productionchart.isRecipe === 0 ? 1 : 0;
      });
    }
  }, [productionchart?.isOpen]);

  const onClearFilter = () => {
    setProductionchart((draft) => {
      draft.filters = {
        search: "",
        stores: [],
        date: [],
      };
      draft.tempdate = [
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ];
      draft.templateDate = "";
    });
  };
  const disableclearButton =
    productionchart.filters.date.length > 0 ||
    productionchart.filters.search ||
    productionchart.filters.stores.length > 0;

  const handleCustomFieldChange = (id, e, fieldType, data) => {
    const { value } = e.target;
    setProductionchart((draft) => {
      draft.dataList = productionchart?.dataList?.map((data, index) => {
        if (index === productionchart.temp_index) {
          return {
            ...data,
            recipeList: data?.recipeList?.map((item) => {
              if (item.id === id) {
                return {
                  ...item,
                  [fieldType]: Number(value),
                  isChanged: true,
                };
              } else return item;
            }),
          };
        } else return data;
      });
    });
  };

  useEffect(() => {
    if (productionchart.isOpen && categorylistQuery?.data?.length) {
      onChangeFilter(categorylistQuery?.data[0]);
      setProductionchart((draft) => {
        draft.isInitialLoad = true;
      });
    }
  }, [productionchart.isOpen, categorylistQuery.data]);

  useEffect(() => {
    const dataList = productionchart?.dataList;
    const templateIndex = productionchart?.temp_index;
    const hasCategory = productionchart?.filter?.category;

    const isContentProcessable =
      dataList && templateIndex !== null && hasCategory;

    if (isContentProcessable) {
      const selectedTemplate = dataList.find(
        (_, index) => index === templateIndex,
      );

      const templateRecipeList = selectedTemplate?.recipeList || [];

      const categoryBasedData = templateRecipeList?.reduce((acc, item) => {
        let key = item["subcategory_id"];
        if (!acc[key]) {
          acc[key] = {
            category_id: item["category_id"],
            subcategory_name: item["subcategory_name"],
            subcategory_display_order: item["subcategory_display_order"],
            subRows: [],
          };
        }
        acc[key].subRows.push(item);
        return acc;
      }, {});

      const categoryBasedDataValues = Object.values(categoryBasedData);
      const sortFn = (a, b) =>
        a.subcategory_display_order - b.subcategory_display_order;

      const templateResult = hasCategory
        ? categoryBasedDataValues
            .filter((v) => productionchart?.filter?.category === v?.category_id)
            .sort(sortFn)
        : categoryBasedDataValues.sort(sortFn);

      const { result, totalSearchResult } = searchFn(
        productionchart.filter.search,
        productionchart.filter.search
          ? categoryBasedDataValues
          : templateResult,
      );
      setProductionchart((draft) => {
        draft.result = templateResult;
        draft.templateResultRows = result;
        draft.totalTemplateSearchResult = totalSearchResult;
        draft.completeTemplateCategories = categoryBasedDataValues;
      });
    }
  }, [
    productionchart?.dataList,
    productionchart.temp_index,
    productionchart.filter.category,
  ]);

  // useEffect(() => {
  //   if (
  //     productionchart?.dataList &&
  //     productionchart?.filter?.category &&
  //     productionchart?.temp_index !== null
  //   ) {
  //     const findData = productionchart?.dataList.find(
  //       (item, index) => index === productionchart?.temp_index,
  //     )?.recipeList;
  //     let groupedData = findData?.reduce((acc, item) => {
  //       let key = item["subcategory_id"];
  //       if (!acc[key]) {
  //         acc[key] = {
  //           category_id: item["category_id"],
  //           subcategory_name: item["subcategory_name"],
  //           subcategory_display_order: item["subcategory_display_order"],
  //           subRows: [],
  //         };
  //       }
  //       acc[key].subRows.push(item);
  //       return acc;
  //     }, {});
  //     if (groupedData) {
  //       let result = !productionchart?.filter?.category
  //         ? Object.values(groupedData).sort(
  //             (a, b) =>
  //               a.subcategory_display_order - b.subcategory_display_order,
  //           )
  //         : Object.values(groupedData)
  //             .filter(
  //               (v) => productionchart?.filter?.category === v?.category_id,
  //             )
  //             .sort(
  //               (a, b) =>
  //                 a.subcategory_display_order - b.subcategory_display_order,
  //             );
  //       setProductionchart((draft) => {
  //         draft.result = result;
  //         draft.templateResultRows = searchFn(
  //           productionchart.filter.search,
  //           result,
  //         );
  //         draft.completeTemplateCategories = groupedData;
  //       });
  //     }
  //   }
  // }, [
  //   productionchart.dataList,
  //   productionchart.temp_index,
  //   productionchart.filter.category,
  // ]);

  const handleResetScroll = () => {
    // reset scrolls
    if (productListRef.current) productListRef.current.scrollTop = 0;
    if (ingredientListRef.current) ingredientListRef.current.scrollTop = 0;
  };

  // Handle selecting an item
  const handleSelect = ({ priority, index }) => {
    setProductionchart((draft) => {
      draft.selectedBatchPriority = priority;
      draft.selectedBatchIndex = index;
    });
    handleResetScroll();
  };

  //Handle recipe selcting an item
  const handleRecipeSelect = (index, item = null) => {
    setProductionchart((draft) => {
      draft.selectedRecipeIndex = index;
      draft.selectedOtherRecipe = item;
    });
  };

  //Handle show error message
  const handleShowErrorMessage = (type) => {
    setProductionchart((draft) => {
      draft.isShowErrorMessage = type;
    });
  };

  //Handle production chart download
  const handleProductionChartDownload = () => {
    downloadProductionChart.mutate({
      payload: {
        date: productionchart?.templateDate,
        store_id: productionchart?.selectedStore?.store_id,
      },
    });
  };

  //batch split section

  const handleBatchSplitUpdate = (productIndex, batchIndex) => {
    setProductionchart((draft) => {
      draft.isBatchSplit = true;
    });
    updateProductionchartBatchSplit.mutate({
      payload: {
        date: productionchart?.templateDate,
        store_id: productionchart?.batchTemplateDetails?.store_id,
        templates: productionchart?.batchDetails,
        type: "edit",
      },
    });
    setEditedMap((prev) => {
      const newMap = { ...prev };
      delete newMap[`${productIndex}-${batchIndex}`];
      return newMap;
    });
    setProductionchart((draft) => {
      draft.batchIndex = batchIndex;
      draft.productIndex = productIndex;
    });
    setFocusedField(null); // Remove highlight
  };
  const handleAddBatch = () => {
    setProductionchart((draft) => {
      draft.isBatchSplit = true;
    });
    const batchDetails = productionchart?.batchDetails || [];

    // Only update the selected batch group (not all)
    const currentBatch = batchDetails[selectedIndex];
    if (!currentBatch) return;

    // Update each product with a new batch item
    const updatedProducts = currentBatch.products.map((product) => ({
      ...product,
      batches: [...product.batches, { units: 0, weight: 0 }],
    }));

    // Merge back updated products into batch
    const updatedBatch = {
      ...currentBatch,
      products: updatedProducts,
      batch_count: currentBatch.batch_count + 1,
    };

    // Only send the updated batch group in the payload (not all batch groups)
    updateProductionchartBatchSplit.mutate({
      payload: {
        date: productionchart?.templateDate,
        store_id: productionchart?.batchTemplateDetails?.store_id,
        templates: [updatedBatch], // Only the selected batch group
        type: "add",
      },
    });
  };
  function removeAllZeroBatches(batchDetails) {
    if (!Array.isArray(batchDetails) || batchDetails.length === 0)
      return batchDetails;

    return batchDetails.map((batchGroup) => {
      const products = batchGroup.products || [];
      if (products.length === 0) return batchGroup;

      // Find the length of batches (assume all products in this group have the same number of batches)
      const batchLength = products[0].batches.length;

      // Find batch indexes where all products in this group have units and weight as 0
      const zeroBatchIndexes = [];
      for (let i = 0; i < batchLength; i++) {
        const allZero = products.every(
          (product) =>
            product.batches[i]?.units === 0 && product.batches[i]?.weight === 0
        );
        if (allZero) zeroBatchIndexes.push(i);
      }

      // Remove those batch indexes from all products' batches arrays in this group
      const updatedProducts = products.map((product) => ({
        ...product,
        batches: product.batches.filter(
          (_, idx) => !zeroBatchIndexes.includes(idx)
        ),
      }));

      // Update batch_count for this group
      const updatedBatch = {
        ...batchGroup,
        products: updatedProducts,
        batch_count: updatedProducts[0]?.batches.length || 0,
      };

      return updatedBatch;
    });
  }
  const handleDeleteBatch = (type) => {
    setProductionchart((draft) => {
      draft.isBatchSplit = true;
    });
    const updatedProducts = productionchart?.batchDetails[
      selectedIndex
    ]?.products?.map((product) => {
      return {
        ...product,
        batches: product.batches.filter(
          (_, index) => index !== productionchart.batchIndex
        ),
      };
    });
    const updatedBatch = {
      ...productionchart?.batchDetails[selectedIndex],
      products: updatedProducts,
      batch_count: productionchart?.batchDetails[selectedIndex].batch_count + 1,
    };
    const updatedBatchDetails = productionchart?.batchDetails.map(
      (batch, index) => (index === selectedIndex ? updatedBatch : batch)
    );
    updateProductionchartBatchSplit.mutate({
      payload: {
        date: productionchart?.templateDate,
        store_id: productionchart?.batchTemplateDetails?.store_id,
        templates:
          type === "all"
            ? removeAllZeroBatches(productionchart.batchDetails)
            : updatedBatchDetails,
        type: "delete",
      },
      handleDeleteBatchDialog,
    });
    setProductionchart((draft) => {
      const currentBatch = draft.batchDetails[selectedIndex];
      currentBatch.products.forEach((product) => {
        product.batches.splice(draft.batchIndex, 1);
      });
    });
  };

  const handleDeleteBatchDialog = (type, batchIndex) => {
    setProductionchart((draft) => {
      draft.isDeleteBatchDialogOpen = type;
      draft.batchIndex = batchIndex;
      draft.allLastBatchWeightZero = false;
    });
  };

  //Handle production chart download
  const onDownloadPCByCategoryId = (id) => {
    downloadProductionChartByCategory.mutate({
      payload: {
        date: productionchart?.templateDate,
        store_id: productionchart?.selectedStore?.store_id,
        category_id: id,
      },
    });
  };

  useEffect(() => {
    if (productionchart?.templateBatchDetails?.length > 0) {
      setProductionchart((draft) => {
        draft.batchDetails =
          productionchart?.templateBatchDetails[productionchart?.temp_index];
      });
    }
  }, [
    productionchart?.templateBatchDetails,
    productionchart.temp_index,
    productionchart.isBatchSplit,
  ]);

  return {
    productionchart,
    pagination,
    handleModal,
    resetRegenerateSearch,
    handleTemplateModal,
    dataList,
    detailsData,
    handleSelectStore,
    setPagination,
    listQuery,
    futureListQuery,
    productionChartDetails,
    templateList,
    sorting,
    setSorting,
    searchHandler,
    storeList,
    handleStoreSelect,
    onChangeDate,
    onChangeDateFuture,
    handleDateChangeApply,
    handleIsOpen,
    handleIsOpenFuture,
    handleViewCharts,
    onSearchChange,
    categorylistQuery,
    handleCustomTableChange,
    handleRecipes,
    recipelistQuery,
    onChangeFilter,
    onTemplateSearchChange,
    updateTableData,
    onStoreChange,
    onUpdate,
    editTemplate,
    filterRecipeList,
    handleTemplateChange,
    convertedData,
    onClearFilter,
    disableclearButton,
    isFututeChartVisble,
    isEditable,
    handleCustomFieldChange,
    handleSelect,
    handleRecipeSelect,
    globalData,
    handleShowErrorMessage,
    handleProductionChartDownload,
    onDownloadPCByCategoryId,
    setProductionchart,
    selectedIndex,
    setSelectedIndex,
    handleBatchSplitUpdate,
    editedMap,
    setEditedMap,
    focusedField,
    setFocusedField,
    updateProductionchartBatchSplit,
    handleAddBatch,
    handleDeleteBatch,
    handleDeleteBatchDialog,
    downloadProductionChart,
    downloadProductionChartByCategory,
    hasAnyBatchError,
    hasLastBatchWeightZero,
    productListRef,
    ingredientListRef,
    toggleAllProducts,
    setToggleAllProducts,
  };
};
